import Vue from "vue";
import {Lang} from "laravel-vue-lang";
import langselector from "./components/LangSelector.vue"
import footerlinks from "./components/FooterLinks.vue"
import store from './store';


Vue.use(Lang, {
    fallback: "en"
});

var app = new Vue({
    store,
    el: "#footer",
    name:"Footer",
    components: {
        langselector,
        footerlinks
    },
    data: {
    },
    computed: {
    },
    methods: {
    },
    filters: {}
});
